module.exports = __webpack_public_path__ + "img/sample.25638d6e.png";